import { type AsyncState, createAsyncStateReducer } from '@essent/common';
import type {
  GetReviewStatisticsV1Response,
  GetReviewsV1Response,
} from '@integration/api-client/reviews';
import type { ActionReducerMap } from '@ngrx/store';

import { reviewActions } from './reviews.entity';

export const reviewsEntitySelectorKey = 'reviews-entity';

export interface ReviewsEntityState {
  getReviews: AsyncState<GetReviewsV1Response>;
  getReviewStatistics: AsyncState<GetReviewStatisticsV1Response>;
}

export const reviewEntityReducers: ActionReducerMap<ReviewsEntityState> = {
  getReviews: createAsyncStateReducer(reviewActions.getReviewsV1),
  getReviewStatistics: createAsyncStateReducer(
    reviewActions.getReviewStatisticsV1
  ),
};
